import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) { }

  public get<T>(url: string, headers: HttpHeaders) {
    return new Promise<T>((resolve, reject) => {
      this.http.get<T>(url, { headers })
        .pipe(retry(0))
        .toPromise()
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public post(url: string, request: any, headers: HttpHeaders) {
    return new Promise((resolve, reject) => {
      this.http.post(url, request, { headers })
        .pipe(retry(0))
        .toPromise()
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public put(url: string, request: any, headers: HttpHeaders) {
    return new Promise((resolve, reject) => {
      this.http.put(url, request, { headers })
        .pipe(retry(0))
        .toPromise()
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public delete(url: string, headers: HttpHeaders) {
    return new Promise((resolve, reject) => {
      this.http.delete(url, { headers })
        .pipe(retry(0))
        .toPromise()
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public upload(url: string, request: FormData, headers: HttpHeaders): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(url, request, {
        headers,
        reportProgress: true,
      })
        .pipe(retry(0))
        .toPromise()
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public fileUpload(url: string, request: FormData, headers: HttpHeaders): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.put(url, request, {
        headers,
        reportProgress: true,
      })
        .pipe(retry(0))
        .toPromise()
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public download(url: string, headers: HttpHeaders) {
    return new Promise((resolve, reject) => {
      this.http.get(url, { headers, responseType: 'arraybuffer' })
        .pipe(retry(0))
        .toPromise()
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public appendAppKeyHeader(key: string, value: string): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.append(key, value);
    return headers;
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';

    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }

    return throwError(errorMessage);
  }
}
